import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

@Injectable({ providedIn: 'root' })
export class HapticsService {
  lightImpact(): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    void Haptics.impact({ style: ImpactStyle.Light }).catch(() => undefined);
  }

  mediumImpact(): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    void Haptics.impact({ style: ImpactStyle.Medium }).catch(() => undefined);
  }

  heavyImpact(): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    void Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => undefined);
  }
}
